import { create } from "mobx-persist";

import authStore from "./authStore";

const hydrate = create({
  storage: localStorage,
});

class RootStore {
  authStore = authStore;

  isHydrationComplete = false;
  constructor() {
    Promise.all([hydrate("authStore", this.authStore)])
      .then(() => {
        this.setHydration(true);
        console.log("Application Hydrated.");
      })
      .catch((err) => {
        this.setHydration(false);
        console.log(err);
      });
  }
  getHydration() {
    return this.isHydrationComplete;
  }
  setHydration(x) {
    this.isHydrationComplete = x;
  }
}

export default new RootStore();
